<template>
    <section class="block block--pad-slider items-center relative overflow-hidden py-10 will-change" :class="computedClass" :data-scroll-section="inner == 'false'">
        <div v-if="blockData.title || blockData.text" class="mb-12 text-center max-w-[738px] mx-auto">
            <h2 class="text-4xl xl:text-title leading-none mb-7" :class="{'text-white': blockData.background_color === 'Dark Blue'}" v-show="blockData.title">{{ blockData.title }}</h2>
            <div class="" v-show="blockData.text" v-html="blockData.text"></div>
        </div>

        <div class="relative">
            <div class="swiper-container h-[50vh] xl:h-[80vh]" ref="slider">
                <div class="swiper-wrapper">
                    <div v-for="( image, index ) in blockData.slides" :key="index" class="swiper-slide">
                        <img class="object-cover w-full h-full" v-show="image.url" :src="image.url" :alt="image.alt">
                    </div>
                </div>
            </div>

            <!-- controls -->
            <div class="controls hidden xl:flex items-center justify-between w-full absolute top-1/2 -translate-y-1/2 left-0 z-30 px-[9vw]">
                <div class="control-left mr-7">
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="30" cy="30" r="29.5" stroke="white"/>
                        <path d="M40 30L21 30" stroke="white" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M24 34L20 30L24 26" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
                    </svg>
                </div>

                <div class="control-right ml-7">
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="30" cy="30" r="29.5" stroke="white"/>
                        <path d="M20 30L39 30" stroke="white" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M36 26L40 30L36 34" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
                    </svg>
                </div>
            </div>
            <!-- ./controls -->
        </div>


        <div class="flexCaption mt-5 xl:mt-10 pb-5" v-if="blockData.more_slides_info">
            <div class="text-center mx-auto md:w-[80%]" >
                <div class="pagination text-sm tracking-desk text-navy-blue-03 mb-4"></div>
                <div class="swiper-container" ref="sliderInfo" thumbsSlider="">
                    <div class="swiper-wrapper">
                        <div v-for="( image, index ) in blockData.slides" :key="index" class="swiper-slide">
                            <div class="text-2xl font-canela tracking-[2px] uppercase mb-4 xl:mb-6" v-show="image.title" v-html="image.title"></div>
                            <div v-show="image.caption" v-html="image.caption"></div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>

        
    </section>
</template>


<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
    export default {
        name: 'SidePaddedImageSlider',
        data() {
            return {
                slider: null,
                sliderInfo: null,

                sliderOptions: {
                    autoplay: {
                        delay: 3500,
                    },
                    speed: 800,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    navigation: {
                        prevEl: '.controls .control-left',
                        nextEl: '.controls .control-right',
                    },
                    pagination: {
                        el: '.flexCaption .pagination',
                        type: 'fraction',
                    },
                    
                },

                
                sliderCaptionOptions:{
                    autoplay: {
                        delay: 3500,
                    },
                    speed: 800,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    watchSlidesProgress: true,
                    loop: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    }
                }
            }
        },
        mounted() {
            this.slider = new Swiper( this.$refs.slider, this.sliderOptions );
            if(this.blockData.more_slides_info) {
                this.sliderInfo = new Swiper( this.$refs.sliderInfo, this.sliderCaptionOptions );
                this.slider.controller.control = this.sliderInfo
                this.sliderInfo.controller.control = this.slider
            }
        },
        methods: {},
        computed: {
            computedClass() {
                let className = '';
                if ( this.blockData.background_color === 'Transparent' ) {
                    className = [
                        'bg-transparent',
                        'text-navy-blue-02'
                    ]
                }
                if ( this.blockData.background_color === 'Light Blue' ) {
                    className = [
                        'bg-light-blue-03',
                        'text-navy-blue-02'
                    ]
                }
                if ( this.blockData.background_color === 'Dark Blue' ) {
                    className = [
                        'bg-navy-blue-01',
                        'text-white'
                    ]
                }
                return className;
            }
        },
    }
</script>
